import {useTheme} from '@primer/react-brand/esm'
import {useId} from 'react'

import Styles from './HeroSequence.module.css'

import {Product} from '../../Product/Product'
import {useHeroSequencePlayback} from './use-hero-sequence-playback'
import type {HeroSequenceProps} from './types'

export type {HeroPlaybackState, HeroSequenceProps} from './types'

export const defaultProps: Partial<HeroSequenceProps> = {}

export const HeroSequence = (props: HeroSequenceProps) => {
  const initializedProps: HeroSequenceProps = {...defaultProps, ...props}
  const {currentChapterIndex, labelledBy, chaptersAltDesc, videoRef} = initializedProps
  const {videoUrl, reportPlayback, handleError} = useHeroSequencePlayback(initializedProps)
  const descriptionId = useId()
  const {colorMode} = useTheme()

  return (
    <div className={Styles['HeroSequence']}>
      <Product
        className={Styles.HeroSequence__product}
        theme={colorMode}
        minPadding="var(--base-size-64)"
        backgroundProps={{hasCornerDots: true}}
        mediaPosition="center-left"
        productUI={{
          className: Styles.HeroSequence__frame,
          shadowColor: 'green',
          shadowPosition: 'left-bottom',
        }}
      >
        <div className={Styles.HeroSequence__content}>
          <span id={descriptionId} hidden>
            {chaptersAltDesc[currentChapterIndex]}
          </span>
          {videoUrl && (
            <video
              className={Styles.HeroSequence__video}
              ref={videoRef}
              src={videoUrl}
              aria-labelledby={labelledBy}
              aria-describedby={descriptionId}
              muted
              playsInline
              preload="metadata"
              onTimeUpdate={reportPlayback}
              onPlay={reportPlayback}
              onPlaying={reportPlayback}
              onPause={reportPlayback}
              onWaiting={reportPlayback}
              onSeeking={reportPlayback}
              onSeeked={reportPlayback}
              onEnded={reportPlayback}
              onError={handleError}
            />
          )}
          {/* TODO: TBC, add JSON animation player component when not using a video? */}
        </div>
      </Product>
    </div>
  )
}
